import React from 'react'

export const IconRoute = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.77452 5.52518C3.57452 2.06518 8.78452 2.06518 9.57452 5.52518C10.0445 7.55518 8.75452 9.27518 7.63452 10.3452C6.81452 11.1252 5.52452 11.1152 4.70452 10.3452C3.59452 9.27518 2.30452 7.55518 2.77452 5.52518Z"
        stroke="#228E82"
        strokeWidth="1.5"
      />
      <path
        d="M15.7745 17.5252C16.5745 14.0652 21.8145 14.0652 22.6145 17.5252C23.0845 19.5552 21.7945 21.2752 20.6645 22.3452C19.8445 23.1252 18.5445 23.1152 17.7245 22.3452C16.5945 21.2752 15.3045 19.5552 15.7745 17.5252Z"
        stroke="#228E82"
        strokeWidth="1.5"
      />
      <path
        d="M12.7044 5.92529H15.3844C17.2344 5.92529 18.0944 8.21529 16.7044 9.43529L8.71441 16.4253C7.32441 17.6353 8.18441 19.9253 10.0244 19.9253H12.7044"
        stroke="#228E82"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.19068 6.42529H6.20224"
        stroke="#228E82"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1907 18.4253H19.2022"
        stroke="#228E82"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
